<div *ngIf="{
          isSaving:selectIsSaving$|async
            } as conditions" class="ui-modal"
>
  <div class="header flex-row space-between-center">
    {{ 'ADD_YOUTUBE.TITLE'|translate }}
    <span class="ui-icon-close c-p" matDialogClose></span>
  </div>
  <div class="body flex-col gap-16" [formGroup]="addYoutubeForm">
    <div class="flex-col gap-8">
      <label>{{ 'ADD_YOUTUBE.NAME'|translate }}</label>
      <input class="ui-input ui-input-40" [placeholder]="'ADD_YOUTUBE.PLACEHOLDERS.NAME'|translate " formControlName="name">
    </div>
    <div class="flex-col gap-8">
      <label>{{ 'ADD_YOUTUBE.URL'|translate }}</label>
      <input class="ui-input ui-input-40" placeholder="https://" formControlName="url">
    </div>
  </div>
  <div class="footer flex-row end-center">
    <ui-button
      [text]="'COMMON.CANCEL'|translate"
      type="default"
      (clickAction)="close()"
    >
    </ui-button>
    <ui-button [loading]="conditions.isSaving"
               type="primary"
               [text]="'COMMON.ADD'|translate"
               (clickAction)="add()"
               [disabled]="addYoutubeForm.invalid"
    ></ui-button>
  </div>
</div>
